import { put } from 'redux-saga/effects';

import { CreateDatasourceExtractTaskActionService } from '~src/extractTask/actions/CreateDatasourceExtractTaskAction';
import { CreateExtractTasksMode } from '~src/extractTask/actions/CreateExtractTaskAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { requestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { CreateRemoteExtractRefreshAction } from '../../actions/remoteExtractRefresh/CreateRemoteExtractRefreshAction';

export function* handleCreateRemoteExtractRefreshAction(action: CreateRemoteExtractRefreshAction) {
  try {
    // Similar to the logic of openDatasourceRefreshExtractDialog
    // in $\src\vizportalclient\src\app\sagas\spaces\extractTasks\CreateExtractRefreshSaga.ts
    // such that clicking "New Extract Refresh" would open the same tabbed dialog
    CreateDatasourceExtractTaskActionService.forDatasource(action.datasource, CreateExtractTasksMode.AllowScheduleOnServerAndClient);
    yield put(requestSpaceContents());
  } catch(e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
